import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Audit, Action, PlantAndManagement } from 'types/BarrierModal'
import { PSEAudit } from 'types/ProcessSafetyElement'

type type = {
  pseAuditData: PSEAudit
  pseAuditDataValidation: any
  isDataUpdated: boolean
  isDataLoaded: boolean
}

const initialState: type = {
  pseAuditData: {} as PSEAudit,
  pseAuditDataValidation: { },
  isDataUpdated: false,
  isDataLoaded: false
}

const PSEAuditFormDataSlice = createSlice({
  name: 'PSEFormDataState',
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<Partial<type>>) => {
      Object.assign(state, action.payload)
    },
    clearPSEAuditState:(state)=>{
      Object.assign(state, initialState)
    },
    updatePSEAuditState: (state, action: PayloadAction<{key: keyof type, value: any}>) => {
      const {key, value} = action.payload
      state[key] = value as any
      state.isDataLoaded = true
    },
    updateNestedState:(state, action: PayloadAction<{key: string, value: any}>) =>{
      const {key, value} = action.payload
      const keys:any = key.split(".")
      let nested:any = state.pseAuditData;
      
      for (let i = 0; i < keys.length - 1; i++) {
        const key = isNaN(keys[i]) ? keys[i] : Number(keys[i]);
        if (!nested[key]) nested[key] = {}; // ensure path exists
        nested = nested[key];
      }
      const finalKey = isNaN(keys[keys.length - 1]) ? keys[keys.length - 1] : Number(keys[keys.length - 1]);
      nested[finalKey] = {...nested[finalKey] ,value};

    state.pseAuditData = nested;
    state.isDataUpdated = true
    },

    addSummaryAction:(state, action: PayloadAction<{key: string, value: any}>) =>{
      const {key, value} = action.payload
      state.pseAuditData.management.actions.push(value)
      state.isDataUpdated = true
    },
    updateSummaryAction:(state, action: PayloadAction<{idx: number, value: any}>) =>{
      const {idx, value} = action.payload
      
      const prev = state.pseAuditData.management.actions[idx]
      state.pseAuditData.management.actions[idx] = {...prev, ...value}
      state.isDataUpdated = true
    },
    updateSummary:(state, action: PayloadAction<{ value: any}>) =>{
      const {value} = action.payload
      const prev = state.pseAuditData.management
      state.pseAuditData.management = {...prev, ...value}
      state.isDataUpdated = true
    },
    deleteSummaryAction:(state, action: PayloadAction<number>) =>{
      const index = action.payload
      if(state.pseAuditData.management.actions.length == 1){
        state.pseAuditData.management.actions = []
      }else{
        state.pseAuditData.management.actions.splice(index, 1)
      }
      // delete state.pseAuditData.management.actions[index]
      state.isDataUpdated = true
    },
    updateQuestionData:(state, action: PayloadAction<{q_index: number, value: any}>)=>{
      const {q_index, value} = action.payload
      const prev= state.pseAuditData.management.questions[q_index]
      state.pseAuditData.management.questions[q_index] = {...prev, ...value}
      state.isDataUpdated = true
    },
    addLevelOneObservation:(state, action: PayloadAction<{q_index: number, value: any}>) =>{
      const {q_index, value} = action.payload
      const PrevState = state.pseAuditData.management.questions[q_index]?.observations ?? []
      state.pseAuditData.management.questions[q_index].observations = [...PrevState, value]
      state.isDataUpdated = true
    },
    updateLevelOneObservation:(state, action: PayloadAction<{q_index: number, idx: number, value: any}>)=>{
      const {q_index, idx, value} = action.payload
      const prev= state.pseAuditData.management.questions[q_index].observations[idx]
      state.pseAuditData.management.questions[q_index].observations[idx] = {...prev, ...value}
      state.isDataUpdated = true
    },
    deleteLevelOneObservation:(state, action: PayloadAction<{q_index: number, idx: number}>) =>{
      const {q_index, idx} = action.payload
      if(state.pseAuditData.management.questions[q_index]?.observations.length ==1){
        state.pseAuditData.management.questions[q_index].observations = []
      }
      state.pseAuditData.management.questions[q_index].observations.splice(idx, 1)
      state.isDataUpdated = true
    },
    updateLevelOneObservationAction:(state, action: PayloadAction<{q_index: number, obs_index: number, idx: number, value: any}>)=>{
      const {q_index, obs_index, idx, value} = action.payload
      const prev = state.pseAuditData.management.questions[q_index].observations[obs_index].actions[idx]
      state.pseAuditData.management.questions[q_index].observations[obs_index].actions[idx] = {...prev, ...value}
      state.isDataUpdated = true
    },
    addLevelOneObservationAction:(state, action: PayloadAction<{q_index: number, obs_index: number, value: any}>)=>{
      const {q_index, obs_index, value} = action.payload
      const PrevState = state.pseAuditData.management.questions[q_index]?.observations[obs_index].actions ?? []
      state.pseAuditData.management.questions[q_index].observations[obs_index].actions = [...PrevState, value]
      state.isDataUpdated = true
    },
    deleteLevelOneObservationAction:(state, action: PayloadAction<{q_index: number, obs_index: number, idx: number}>)=>{
      const {q_index, obs_index, idx} = action.payload
      if(state.pseAuditData.management.questions[q_index]?.observations[obs_index].actions.length == 1){
        state.pseAuditData.management.questions[q_index].observations[obs_index].actions = []
      }else{
        state.pseAuditData.management.questions[q_index]?.observations[obs_index].actions.splice(idx, 1)
      }
      state.isDataUpdated = true
      
    }
  }
});

export const {
  setFormData,
  updateSummary,
  addSummaryAction,
  updateNestedState,
  updateQuestionData,
  clearPSEAuditState,
  updateSummaryAction,
  deleteSummaryAction,
  updatePSEAuditState,
  addLevelOneObservation,
  updateLevelOneObservation,
  deleteLevelOneObservation,
  addLevelOneObservationAction,
  updateLevelOneObservationAction,
  deleteLevelOneObservationAction,
} = PSEAuditFormDataSlice.actions
export default PSEAuditFormDataSlice.reducer